<template>
	<div style="height: 100%;">
		<el-card>
			<div
				style="display: grid;grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr; grid-template-rows: 1fr 1fr;gap: 10px 10px;color: white;">
				<el-card shadow="always" :body-style="{backgroundColor: '#0074D9'}">
					<div style="color: white;">待审核门店：{{data.static1}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(104,194,21)'}">
					<div style="">待审核扣款：{{data.static2}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(161,23,21)'}">
					<div style="">待审核提现：{{data.static3}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(227,160,93)'}">
					<div style="">进行中授权：{{data.static4}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(38,151,128)'}">
					<div style="">已完成授权：{{data.static5}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(34,8,7)'}">
					<div style="">预授权总金额：{{data.static6}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(255,67,101)'}">
					<div style="">扣款申请：{{data.static7}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(131 ,175,155)'}">
					<div style="">扣款金额：{{data.static8}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(110,112,73)'}">
					<div style="">合作门店：{{data.static9}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(30,41,61)'}">
					<div style="">扣款失败：{{data.static10}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(153,77,82)'}">
					<div style="">扣款撤销：{{data.static11}}</div>
				</el-card>
				<el-card shadow="always" :body-style="{backgroundColor: 'rgb(78,29,76)'}">
					<div style="">扣款成功：{{data.static12}}</div>
				</el-card>
			</div>
		</el-card>
		<el-card shadow="always" style="margin-top: 15px;">
			<div id="echarts_box" style="width: 600px;height:400px;"></div>
		</el-card>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				data: {}
			};
		},
		methods: {
			getData() {
				var that = this;
				this.$axios.post('zuche/admin/getHomeData', {}).then(function(res) {
					if (res.data.success) {
						that.data = res.data.result;
						var myChart = echarts.init(document.getElementById('echarts_box'))
						// var option = {
						// 	xAxis: {
						// 		type: 'category',
						// 		data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
						// 	},
						// 	yAxis: {
						// 		type: 'value'
						// 	},
						// 	series: [{
						// 		data: [120, 200, 150, 80, 70, 110, 130],
						// 		type: 'bar'
						// 	}]
						// };
						//  myChart.setOption(option);
					} else {
						that.$message.error(res.data.message);
					}
				});
			}
		},
		mounted() {
			this.getData();

		},
		destroyed() {

		}
	};
</script>

<style>
	.el-card {
		color: white;
	}

</style>


// WEBPACK FOOTER //
// src/components/home.vue